import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealLines } from "./Reveal";
import { MagneticButton } from "./MagneticButton";

export const CTASection = ({
  heading = ["READY TO MOVE YOUR", "BUSINESS FORWARD?"],
  text = "Let's turn your next challenge into your next opportunity.",
}) => (
  <section className="relative overflow-hidden gradient-bg noise-overlay" data-testid="cta-section">
    <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24 text-center">
      <h2 className="font-heading font-extrabold text-white text-4xl md:text-7xl leading-[1.03] tracking-tight">
        <RevealLines lines={heading} />
      </h2>
      <Reveal delay={0.2}>
        <p className="mt-8 text-white/90 text-lg md:text-2xl max-w-2xl mx-auto">{text}</p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <MagneticButton
            as="div"
            className="w-full sm:w-auto"
          >
            <Link
              to="/contact"
              data-testid="cta-start-conversation"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-brand-primary text-base font-bold px-8 py-4 hover:bg-white/90 transition-colors duration-300 w-full sm:w-auto"
            >
              START A CONVERSATION <ArrowUpRight className="h-5 w-5" />
            </Link>
          </MagneticButton>
          <Link
            to="/projects"
            data-testid="cta-view-projects"
            className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/70 text-white text-base font-bold px-8 py-4 hover:bg-white/10 transition-colors duration-300 w-full sm:w-auto"
          >
            VIEW OUR PROJECTS
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
